var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditContainer',{attrs:{"cv-id":_vm.$route.params.cv_id,"section-item":_vm.cvSectionSkillItem}})}
var staticRenderFns = []

export { render, staticRenderFns }